import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LocalCacheService } from '../../../../shared/services/local-cache.service';

@Component({
    selector: 'app-banner-new-instructions',
    templateUrl: './banner-new-instructions.component.html',
    styleUrls: ['./banner-new-instructions.component.scss']
})
export class BannerNewInstructionsComponent implements OnInit, OnDestroy {
    @Input() public actived: boolean = false;
    @Input() public isNewInstructions: boolean | null = null;

    private routerSubscription: Subscription | null = null;

    public constructor(private router: Router, private localCacheService: LocalCacheService) {}

    public ngOnInit(): void {
        if (this.isNewInstructions === null) {
            this.isNewInstructions = this.router.url.includes('/v3/');
        }

        this.localCacheService.clearItem('newInstructions');

        this.routerSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.checkBannerVisibility();
        });

        this.checkBannerVisibility();
    }

    public ngOnDestroy(): void {
        this.routerSubscription?.unsubscribe();
    }

    private checkBannerVisibility(): void {
        if (this.isNewInstructions === false && (this.router.url.includes('invoice') || this.router.url.includes('screenshot'))) {
            this.actived = false;
        } else {
            this.actived = true;
        }
    }

    public navigateOtherInstructions(): void {
        let newUrl: string;

        if (this.isNewInstructions) {
            newUrl = this.router.url.replace('/v3/', '/');
            this.localCacheService.clearItem('newInstructions');
        } else {
            newUrl = this.router.url.replace('/transactions/', '/transactions/v3/');
            // this.localCacheService.setItem('newInstructions', true);
        }

        this.router.navigateByUrl(newUrl);
    }
}
